<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import { useSwiper } from '~/composables/common/use-swiper'
import { useBanners } from '~/composables/home/use-banners'
import { BannerSliderExtra } from '~/resources/home/banners'
import { useLighthouse } from '~/composables/common/use-lighthouse'


const Skeleton = defineAsyncComponent(async () => await import('~/components/common/skeleton.vue'))
const AnimatedNumber = defineAsyncComponent(async () => await import('~/components/common/animated-number.vue'))

const { isLighthouseBot } = useLighthouse()
const { clickBannerSlide, banners, getBanners, jackpotXocdia } = useBanners()
const { modules } = useSwiper()

if (!isLighthouseBot) {
  await getBanners()
}
</script>

<template>
  <div>
    <div id="heroBannerContainer">
      <div id="heroBanner" class="hero-banner">
        <template v-if="banners?.length">
          <Swiper
            :modules="modules"
            :slidesPerView="1"
            :autoplay="
              isLighthouseBot
                ? false
                : {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                  }
            "
            :centeredSlides="true"
            :spaceBetween="0"
            loop
            :pagination="{
              clickable: true
            }"
            :initialSlide="0"
          >
            <template v-if="jackpotXocdia.gameId">
              <SwiperSlide v-for="(item, index) in BannerSliderExtra" :key="`${index}-jackpot`">
                <div @click="clickBannerSlide({ ...item, gameId: jackpotXocdia.gameId })">
                  <div class="ratio">
                    <img
                      format="webp"
                      :src="item.imgSrc"
                      alt="banner"
                      width="1272"
                      height="362"
                      densities="x1 x2"
                      preload
                    />
                    <div class="jackpot-block">
                      <div class="jackpot-block-game">{{ jackpotXocdia.gameName }}</div>
                      <div class="jackpot-block-number">
                        <AnimatedNumber :number="jackpotXocdia.value" :start="jackpotXocdia.value" />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </template>
            <SwiperSlide v-for="(item, index) in banners" :key="index">
              <div @click="clickBannerSlide(item)">
                <div class="ratio">
                  <NuxtImg
                    format="webp"
                    :src="item.imgSrc"
                    alt="banner image"
                    width="1272"
                    height="362"
                    densities="x1 x2"
                    preload
                  />
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </template>
        <Skeleton v-else height="450px" />
      </div>
    </div>
    <div id="custom-pagination"></div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/home/hero-banner.scss';
</style>
